import React from "react";
import aboutImg from "../assets/lisbon.jpg"; // Use your actual about image

function AboutSection() {
  return (
    <section className="about-section">
      <div className="about-text">
        <h2>Who We Are?</h2>
        <p>
          At CareNest Services, we aim to provide support in all stages of life
          for people with different abilities. We work with the broader
          community to bring about positive changes for individuals and society.
          We recognise that all people have the right to equal opportunities and
          justice and can participate fully within their communities regardless
          of their disabilities.
        </p>
        <p>
          We understand the importance of personalised support, and that’s why
          we work closely with each of our clients to create individualised
          plans that meet their unique needs and goals. Our team of experienced
          and compassionate support workers is dedicated to helping our clients
          achieve their full potential and lead meaningful lives.
        </p>
        <button className="about-btn">Read More &nbsp;»</button>
      </div>
      <div className="about-img-wrap">
        <img src={aboutImg} alt="About Us" className="about-img" />
      </div>
    </section>
  );
}

export default AboutSection;
